import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Grid, Typography, CardMedia } from '@mui/material';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import { useParams } from 'react-router';
import { Loading, Navbar, ReturnButton } from '../../../components';
import * as EventActions from '../../../core/events/action';
import * as VendorEventsActions from '../../../core/vendor-events/action';
import { VENUE_NAVBAR_MENU } from '../../../constants/navbar';
import AboutYourEvent from './components/AboutYourEvent';
// import GettingThere from './components/GettingThere';
import AboutYourVenue from './components/AboutYourVenue';
// import MeetOtherVendors from './components/MeetOtherVendors';
// import CancellationPolicies from './components/CancellationPolicies';
import CheckIcon from './components/CheckIcon';
import PointOfContact from './components/PointOfContact';
import VenueButton from '../../../components/Messenger/ChatButton/VenueButton';
import { VENUE_FEATURES } from '../../../constants/venue';
import { useStorageImage } from '../../../hooks/useStorageImage';
import DefaultPhoto from '../../../assets/img/default-img.png';
import { APPLICATION_STATUS } from '../../../constants/event-application-status';

export default function VendorEventGuide() {
  const [title] = useState('Vendor Event Guide');
  const { event, loading } = useSelector((store) => store.events);
  const { venueDetails } = useSelector((store) => store.venues);
  const [seeDigitalMarketing, setSeeDigitalMarketing] = useState(false);

  const { id: eventId } = useParams();
  const dispatch = useDispatch();
  const { user } = useSelector((store) => store.users);
  const image = useStorageImage(event?.photo);
  const {
    vendorEvents: { currentVendorEvent, loading: vendorEventsLoading },
  } = useSelector((store) => store);

  const getVeneFeatureFree = () => {
    const iconList = [];
    if (venueDetails?.length <= 0) return [];

    venueDetails?.link_venue_features.forEach((fe) => {
      const wanted = VENUE_FEATURES.find((i) => i.id === fe.fk_feature);
      if (wanted) iconList.push(wanted);
    });
    return iconList;
  };

  useEffect(() => {
    dispatch(EventActions.getEventById(eventId, user?.role?.name));
    dispatch(VendorEventsActions.findVendorEventRegistered(user?.id, eventId));
  }, [dispatch, eventId, user?.role.name, user?.id]);

  useEffect(() => {
    setSeeDigitalMarketing(false);
    console.log('🍉 User role  ', user?.role?.id);
    if (user?.role?.id === 5 || user?.role?.id === 2) {
      setSeeDigitalMarketing(true);
      console.log('🍉 Granted ');
    } else if (user?.role?.id === 1) {
      console.log('🍉 Vendor, status for this event is: ', currentVendorEvent?.application_status);
      if (currentVendorEvent?.application_status === APPLICATION_STATUS.APPROVED)
        setSeeDigitalMarketing(true);
    } else {
      setSeeDigitalMarketing(false);
    }
  }, [event, currentVendorEvent, user?.role?.id]);

  useEffect(() => {
    if (event?.parameters_event?.digital_marketing) {
      dispatch(EventActions.getDigitalMarketing(event?.id));
    }
  }, [event?.parameters_event?.digital_marketing, dispatch, event?.id]);

  return (
    <>
      {loading && <Loading />}
      <Navbar elements={VENUE_NAVBAR_MENU} />
      <Grid container justifyContent="space-evenly">
        <Typography variant="h4" fontWeight="bold" marginTop={9}>
          {title}
        </Typography>
      </Grid>

      <Grid container justifyContent="space-evenly">
        <Grid item md={2} marginLeft={{ md: 20 }}>
          <ReturnButton />
        </Grid>
        <Grid item md>
          <Typography variant="h6" paddingX={4}>
            a collection of resources to help you navigate the venue & help you make the most out of
            your event!
          </Typography>
        </Grid>
      </Grid>

      <Grid container marginTop={5} justifyContent="center">
        <Grid
          item
          sm={11}
          backgroundColor="#FCE5DD"
          borderRadius="45px"
          paddingX={{ xs: 5, md: 10, xl: 20 }}
          paddingBottom={3}
          marginBottom={3}
          marginX={{ xs: 1, xl: 20 }}
          justifyContent="space-evenly">
          <div>
            <Typography variant="h5" color="#EE7B57" marginTop={4} textAlign="center">
              {event.name}
            </Typography>
          </div>
          <Grid container justifyContent="space-between" marginTop={1}>
            <Grid item xs={16} lg="auto" borderRadius="15px">
              <CardMedia
                component="img"
                height="350"
                style={{ borderRadius: '20px' }}
                image={image || DefaultPhoto}
                alt=""
              />
            </Grid>
            <Grid item xs={16} lg={7}>
              <AboutYourEvent
                venue={venueDetails}
                freeFeatures={getVeneFeatureFree()}
                event={event}
                registeredAttendees={53}
                vendors={27}
                foodTrucks={3}
                seeDigitalMarketing={seeDigitalMarketing}
              />
            </Grid>

            {/* <Grid container marginY={3}>
              <GettingThere />
            </Grid> */}
            <Grid container marginY={3}>
              <AboutYourVenue
                event={event}
                venue={venueDetails}
                surcharges={event?.surcharges}
                freeFeatures={getVeneFeatureFree()}
              />
            </Grid>
            <Grid container>
              <PointOfContact event={event} />
            </Grid>
          </Grid>
        </Grid>
      </Grid>
      <VenueButton venue={event?.venue} />
    </>
  );
}
